import { Component, OnInit } from '@angular/core';

import { StudentGradeLevelService } from '@app/core/services/student-grade-level/student-grade-level.service';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

@Component({
  selector: 'app-filter-grade-level',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class GradeLevelFilterComponent extends FilterComponent implements OnInit {
  public readonly width = 'auto';
  public readonly label = 'MAP Grade Level';

  constructor(private readonly _data: StudentGradeLevelService) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateLevel(value);
    this.valueChange.emit(new FilterChange(FilterType.StudentGradeLevel, value));
  }

  ngOnInit() {
    this.init(
      this._data.studentGradeLevel$,
      this._data.studentGradeLevels$,
      this._data.studentGradeLevels$,
      'level',
      'level'
    );
  }
}
